import React from 'react';
import { get } from 'lodash';
import { useSelector } from 'react-redux';
import { getUserProfile } from '@store/common/selectors';
import RenderSource from './RenderSource';
import AppViewerSession from './AppUserSession';
import { customerOverrideForDrilldown } from '../../utils';

interface IProps {
  column: {
    dataKey: string;
  };
  cellData: any;
  rowData: {
    [k: string]: any;
  };
  columns: any[];
  flowId?: number;
}

const CustomCell = (cellProps: IProps) => {
  const profile = useSelector(getUserProfile);
  const { column, cellData, rowData, flowId } = cellProps;
  const userIdKey = customerOverrideForDrilldown[profile.customer_id] || 'app_user_id';
  const clientIdKey = 'client_id';
  const renderers = {
    [userIdKey]: (
      <AppViewerSession
        flowId={flowId}
        userId={rowData[userIdKey]}
        clientId={rowData[clientIdKey]}
        type="user"
      />
    ),
    [clientIdKey]: <AppViewerSession clientId={rowData[clientIdKey]} flowId={flowId} type="client" />,
  };

  const renderer = get(
    renderers,
    [column.dataKey],
    <RenderSource data={cellData} column={column} />,
  );
  return renderer;
};

export default CustomCell;
